import React, { forwardRef } from 'react';
import { styled } from '@mui/material';
import { spacing, SpacingProps } from '@mui/system';
import EDBox from '../../EDBox/EDBox';

interface IProps extends SpacingProps {
  className?: string;
  children: React.ReactNode;
  fullHeight?: boolean;
}

const EDFullscreenPaperStyled: React.FC<React.PropsWithChildren<IProps>> =
  forwardRef((props, ref) => {
    return (
      <EDBox
        ref={ref}
        tabIndex={-1} //MUI ger annars fel att det krävs tabIndex -1 "for assistive technologies" (och sätter det själv)
        sx={[
          {
            display: 'flex',
            flexDirection: 'column',
            flex: '0 1 100%',
            maxHeight: 'none',
            width: '100%',
            maxWidth: '100%',
            background: (theme: any) => theme.palette.background.default,
          },
          Boolean(props.fullHeight) && {
            height: '100%',
          },
        ]}
      >
        {props.children}
      </EDBox>
    );
  });
export const EDNavigationOverlayPaper: React.FC<
  React.PropsWithChildren<IProps>
> = styled(EDFullscreenPaperStyled, {
  name: 'EDNavigationOverlayPaper',
})(spacing);
